import { StandardObject, type WireIssue } from '../../../interfaces/api/CustomerReport';
import type { ValidatedProblem } from '../../../interfaces/containers/premises/ValidatedProblem';

function wireOnTreeNeedsTrimming(wireIssue: WireIssue): boolean {
	// Make sure there's a tree on the wire
	const treeOnWire = wireIssue?.objectOnWire?.includes(StandardObject.Tree);
	if (!treeOnWire) {
		return false;
	}

	return true;
}

export function treeTrimIssue(problem: ValidatedProblem): boolean {
	// There's a tree on a pole to pole wire
	const poleToPoleNeedsTrimming = wireOnTreeNeedsTrimming(problem?.symptoms?.poleToPoleWire);
	if (poleToPoleNeedsTrimming) {
		return true;
	}

	// There's a tree on a pole to building wire
	const poleToBuildingNeedsTrimming = wireOnTreeNeedsTrimming(problem?.symptoms?.poleToBuildingWire);
	if (poleToBuildingNeedsTrimming) {
		return true;
	}

	return false;
}
